import {baseURL} from '.';
import {get} from './common';

export const loadGamesAsync = async (locale, brand) => {
    let query = `{ games(language: ${locale.toUpperCase()}, brand: ${brand.toUpperCase()}) { id title description url orientation image showName internationalCategory internationalTitle soundIssue slug } }`;

    let result = await get(`${baseURL}/?query=${encodeURI(query)}`);
    if (result.data.games) {
        return result.data.games;
    }
    throw new Error('Games list load failed');
};
